/******/ (() => { // webpackBootstrap
/* eslint-disable */
if (!customElements.get('size-guide-link')) {
  customElements.define('size-guide-link',
  class SizeGuideLink extends HTMLElement {
    constructor() {
      super();
      
      this.cacheDOMElements();
      this.handleClickBound = this.handleClick.bind(this);
    }

    cacheDOMElements() {
      this.sizeGuideLink = this.querySelector('[data-size-guide-link]');
    }

    connectedCallback() {
      this.sizeGuideLink.addEventListener('click', this.handleClickBound);
    }

    disconnectedCallback() {
      this.sizeGuideLink.removeEventListener('click', this.handleClickBound);
    }

    handleClick(event) {
      event.preventDefault();
      const tableTemplate = this.querySelector('[data-size-guide-table-content]');
      if (tableTemplate) {
        window.eventBus.emit('open:size:guide', { content: tableTemplate.innerHTML });
      } else {
        window.eventBus.emit('open:size:guide', { url: event.currentTarget.href });
      }
    }
  });
}
/******/ })()
;